import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const sendBatchSearchRequest = (requestPayload: string[]): AxiosPromise<BatchSearchResponseType> => csttFacadeApi.post('/csttfacade/equipment/v2/equipments/details', requestPayload, { timeout: 300000  } )

export { sendBatchSearchRequest }